<article class="category">
  <picture class="category__image bg-black-light-gradient">
    <img
      [src]="image"
      alt=""
      loading="lazy"
      class="w-full h-full aspect-[3/2] object-cover"
    />
  </picture>
  <div
    class="absolute top-0 left-0 flex flex-col justify-end w-full h-full p-l text-white bg-light-black-gradient"
  >
    <h2 class="text-2xl font-semibold font-regular">{{ title }}</h2>
    <p *ngIf="description" class="">
      {{ description }}
    </p>
  </div>
</article>
